<template>
  <div>
    <general-table
      ref="generalTable"
      :api-url="APIURL"
      :edit-component="editComponent"
      :delete-content="false"
      :block-content="false"
      :edit-content="true"
      :view-content="false"
      :columns="columns"
      :type="type"
      :per-page="perPage"
    >
      <template #cell(engineers)="data">
        <!-- {{ engineers }} -->
        <slot
          name="actions"
          v-bind="data"
        >
          <div style="text-align: center;">
            <feather-icon
              icon="UsersIcon"
              size="16"
              class="mr-50 cursor-pointer"
              @click="ApprovalRow(data.item.engineers)"
            />
          </div>
        </slot>
      </template>
      <template #cell(components)="data">
        <slot
          name="info"
          v-bind="data"
        >
          <div class="text-center">
            <span title="View">
              <feather-icon
                icon="EyeIcon"
                class="cursor-pointer"
                @click="
                  $router.push({
                    name: 'components',
                    params: { CM_id: data.item.id, Components_Name: data.item.name.en}
                  })
                "
              />
            </span>
          </div>
        </slot>
      </template>
      <template #cell(copy_certificate_components)="data">
        <slot
          name="info"
          v-bind="data"
        >
          <div class="text-center">
            <span title="Copy">
              <feather-icon
                icon="CopyIcon"
                class="cursor-pointer"
                @click="toggleModal(data.item.id)"
              />
              <b-modal
                :id="`modal-${data.item.id}`"
                :visible="modalShow[data.item.id] || false"
                centered
                size="lg"
                :title="`Copy Certificate Components`"
                ok-only
                ok-variant="dark"
                ok-title="Close"
                @hide="closeModal(data.item.id)"
              >
                <h3 class="my-4">provide the ID of the certificate the component should be added</h3>
                <div
                  v-if="loader"
                  class="d-flex align-items-center justify-content-center"
                >
                  <b-spinner
                    style="width: 3rem; height: 3rem;"
                    label="Large Spinner"
                    variant="primary"
                  />
                </div>
                <div v-else>
                  <b-form-tags
                    v-model="copyArrayComponents"
                    no-outer-focus
                    class="mb-2"
                    type="number"
                  >
                    <!-- <template #invalid-tag="{ tag }">
                    </template> -->
                    <template v-slot="{ inputAttrs, inputHandlers, addTag, removeTag }">
                      <!-- <span class="text-danger">The tag "{{ tag }}" is invalid. Only numbers are allowed.</span> -->
                      <b-input-group aria-controls="my-custom-tags-list">
                        <input
                          v-bind="inputAttrs"
                          type="number"
                          placeholder="New tag - Press enter to add"
                          class="form-control"
                          v-on="inputHandlers"
                        >
                        <b-input-group-append>
                          <b-button
                            variant="primary"
                            @click="addTag()"
                          >Add</b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <ul
                        id="my-custom-tags-list"
                        class="list-unstyled d-inline-flex flex-wrap mb-0"
                        aria-live="polite"
                        aria-atomic="false"
                        aria-relevant="additions removals"
                      >
                        <b-card
                          v-for="tag in copyArrayComponents"
                          :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                          :key="tag"
                          tag="li"
                          class="mt-1 mr-1"
                          body-class="py-1 pr-2 text-nowrap"
                        >
                          <strong>{{ tag }}</strong>
                          <b-button
                            variant="link"
                            size="sm"
                            :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                            @click="removeTag(tag)"
                          >remove</b-button>
                        </b-card>
                      </ul>
                    </template>
                  </b-form-tags>
                </div>
                <b-alert
                  v-model="showDismissibleAlert"
                  variant="danger"
                >
                  {{ errorMes }}
                </b-alert>
                <div class="d-flex justify-content-end">
                  <b-button
                    variant="primary"
                    @click="CopyComponentsAPi(data.item.id)"
                  >Copy Components {{ data.item.id }}</b-button>
                </div>
              </b-modal>
            </span>
          </div>
        </slot>
      </template>
      <template #cell(add_engineers)="data">
        <slot
          name="actions"
          v-bind="data"
        >
          <b-badge
            class="cursor-pointer"
            @click="$router.push({name: 'edit-eng-on-cert',
                                  params: {
                                    MCR_id: $route.params.MCR_id,
                                    id: data.item.id
                                  }})"
          >
            add engineers
          </b-badge>
        </slot>
      </template>

      <!-- A certificate can belong to several certificate groups (many-to-many). -->
      <template #cell(certificate_category_name)="data">
        <ul
          v-if="data.item.certificate_groups && data.item.certificate_groups.length"
          class="cert-group-list"
        >
          <li
            v-for="group in data.item.certificate_groups"
            :key="group.id"
          >
            {{ group.name }}
          </li>
        </ul>
        <span
          v-else
          class="text-muted"
        >-</span>
      </template>

      <template #cell(gruop)="data">
        <feather-icon
          :icon="data.item.certificate_groups && data.item.certificate_groups.length ? 'EditIcon' : 'PlusCircleIcon'"
          class="cursor-pointer"
          @click="openGroupsModal(data.item)"
        />
      </template>

      <template #cell(types)="data">
        <!-- {{ data.item.certificate_category_name }} -->
        <span v-if="data.item.certifcate_type_name">
          <feather-icon
            icon="EditIcon"
            class="cursor-pointer"
            @click="addToType(data.item.id)"
          />
        </span>
        <span v-else>
          <feather-icon
            icon="PlusCircleIcon"
            class="cursor-pointer"
            @click="addToType(data.item.id)"
          />
        </span>

      </template>

    </general-table>

    <b-modal
      v-model="groupsModal.show"
      title="Certificate Groups"
      size="lg"
      ok-title="Save"
      :ok-disabled="groupsModal.saving"
      @ok.prevent="saveGroups"
    >
      <p class="mb-50">
        <strong>{{ groupsModal.certificateName }}</strong>
      </p>
      <p class="text-muted small">
        Select every certificate group this certificate covers - one certificate can be in several groups.
      </p>
      <v-select
        v-model="groupsModal.selected"
        :options="groupOptions"
        label="name"
        :reduce="group => group.id"
        multiple
        :close-on-select="false"
        placeholder="Search and select groups"
      />
    </b-modal>

  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import vSelect from 'vue-select'
import GeneralTable from '@/components/general-table/GeneralTable.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  components: { GeneralTable, vSelect },
  data() {
    return {
      APIURL: `certificate/${this.$route.params.MCR_id}`,
      addType: 'Add Certificate',
      addComponentName: 'add-certificate',
      errorMes: '',
      editComponent: 'edit-certificate',
      viewContent: true,
      type: 'page',
      perPage: 50,
      modalShow: {},
      loader: false,
      copyArrayComponents: [],
      showDismissibleAlert: false,
      groupCertificate: [],
      typeCertificate: [],
      groupsModal: {
        show: false,
        saving: false,
        certificateId: null,
        certificateName: '',
        selected: [],
        current: [],
      },
      columns: [
        { key: 'id', sortable: false },
        { key: 'name.ar', label: 'Certificate Name Ar' },
        { key: 'name.en', label: 'Certificate Name En' },
        { key: 'description.ar', label: 'Description Certificate Ar' },
        { key: 'description.en', label: 'Description Certificate En' },
        { key: 'copy_certificate_components', label: 'Copy Certificate Components' },
        { key: 'components', label: 'show components' },
        { key: 'engineers', label: 'Engineers' },
        { key: 'certificate_category_name', label: 'Certificate Group' },
        { key: 'gruop', label: 'Gruop Action' },
        { key: 'certifcate_type_name', label: 'Certificate Types' },
        { key: 'types', label: 'Types Action' },
        { key: 'add_engineers', label: 'Assign Engineers' },
        { key: 'actions' },
      ],
    }
  },
  computed: {
    // All groups, plus the certificate's own groups so they show by name even before the full
    // list has loaded.
    groupOptions() {
      const known = new Set(this.groupCertificate.map(group => group.id))
      return [...this.groupCertificate, ...this.groupsModal.current.filter(group => !known.has(group.id))]
    },
  },
  mounted() {
    this.getGroupCer()
    this.getTypeCer()
  },
  methods: {
    formatEngineerNames(names) {
      return `
         <table style="border: 0.5px solid; border-collapse: collapse; margin-top: 18px!important; text-align: center; margin: auto;">
          <tr style="background-color: #f3f2f7">
            <th style="border: 0.5px solid; padding: 8px; text-align: left;">#</th>
            <th style="border: 0.5px solid; padding: 8px; text-align: left;">Engineer Names</th>
            <th style="border: 0.5px solid; padding: 8px; text-align: left;">Status</th>
          </tr>
          ${names.map(
    (name, index) => `
            <tr>
              <td style="border: 1px solid; padding: 8px; text-align: center !important;">${index + 1}</td>
              <td style="border: 1px solid; padding: 8px; text-align: center !important; text-wrap: wrap !important;">${String.raw`${name.engineer_name}`} </td>
              <td style="border: 1px solid; padding: 8px; text-align: center !important; min-width: 250px; text-wrap: wrap !important;">${name.status}</td>
            </tr>`,
  )
    .join('')}
        </table>
      `
    },
    CopyComponentsAPi(id) {
      this.loader = true
      const formData = new FormData()

      formData.append('src_certificate_id', id)
      this.copyArrayComponents.forEach((item, index) => {
        formData.append(`dst_certificate_ids[${index}]`, item) // Append the value of each item
      })

      axios
        .post(
          'certificate/copy-components',
          formData,
        )
        .then(res => {
          if (res.status === 200) {
            this.closeModal(id)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Copy Successfully',
                icon: 'BellIcon',
                variant: 'success',
              },
            })
          }
        })
        .catch(error => {
          if (error.response.status) {
            this.showDismissibleAlert = true
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
            this.errorMes = errorMessage
          }
        })
        .finally(() => {
          this.loader = false
        })
    },

    ApprovalRow(name) {
      this.$swal({
        title: 'Engineer List',
        html: this.formatEngineerNames(name),
        width: 600,
        // text: this.formatEngineerNames(name),
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Close',
      })
    },
    toggleModal(id) {
      // Toggle the modal visibility for the given ID
      this.$set(this.modalShow, id, !this.modalShow[id])
    },
    closeModal(id) {
      // Close the modal when it's hidden
      this.$set(this.modalShow, id, false)
      this.copyArrayComponents = []
      this.errorMes = ''
      this.showDismissibleAlert = false
    },
    getGroupCer() {
      axios.get('certificate-categories').then(res => {
        this.groupCertificate = decryptData(res.data.payload).data.data.map(item => ({
          id: item.id,
          name: item.name,
        }))
      })
    },
    getTypeCer() {
      axios.get('certificate-types').then(res => {
        this.typeCertificate = decryptData(res.data.payload).data.data.map(item => ({
          id: item.id,
          name: item.name,
        }))
      })
    },

    openGroupsModal(item) {
      this.groupsModal = {
        show: true,
        saving: false,
        certificateId: item.id,
        certificateName: (item.name && (item.name.en || item.name.ar)) || `#${item.id}`,
        selected: (item.certificate_groups || []).map(group => group.id),
        current: item.certificate_groups || [],
      }
      if (!this.groupCertificate.length) this.getGroupCer()
    },
    saveGroups() {
      this.groupsModal.saving = true
      axios.put(`certificate/${this.$route.params.MCR_id}/${this.groupsModal.certificateId}`, {
        certificate_category_ids: this.groupsModal.selected,
      })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: { title: 'Certificate groups saved', icon: 'CheckIcon', variant: 'success' },
          })
          this.groupsModal.show = false
          this.$refs.generalTable.getAllData(1)
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: { title: err.response?.data?.message || 'Failed to save certificate groups', icon: 'BellIcon', variant: 'error' },
          })
        })
        .finally(() => {
          this.groupsModal.saving = false
        })
    },

    addToGroup(id) {
      this.$swal({
        title: 'Add Certificate To Group',
        width: 600,
        html: `
      <label for="groupSelect">Select Group:</label>
      <select id="groupSelect" class="swal2-input">
        <option value="" disabled selected>--Select a group--</option>
        ${this.groupCertificate.map(group => `<option value="${group.id}">${group.name}</option>`).join('')}
      </select>
    `,
        showCancelButton: true,
        confirmButtonText: 'Add',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        preConfirm: () => {
          const selectedGroupId = document.getElementById('groupSelect').value
          if (!selectedGroupId) {
            this.$swal.showValidationMessage('Please select a group')
            return false
          }
          return selectedGroupId
        },
      }).then(result => {
        if (result.isConfirmed) {
          const payload = {
            certificate_category_id: result.value,
          }

          axios.put(`certificate/${this.$route.params.MCR_id}/${id}`, payload)
            .then(() => {
              this.$toast.success('Certificate added to group!')
              this.$refs.generalTable.getAllData(1)
            })
            .catch(() => {
              this.$toast.error('Failed to add certificate.')
            })
        }
      })
    },

    addToType(id) {
      this.$swal({
        title: 'Add Certificate To Type',
        width: 600,
        html: `
      <label for="typeSelect">Select Type:</label>
      <select id="typeSelect" class="swal2-input">
        <option value="" disabled selected>--Select a type--</option>
        ${this.typeCertificate.map(group => `<option value="${group.id}">${group.name}</option>`).join('')}
      </select>
    `,
        showCancelButton: true,
        confirmButtonText: 'Add',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        preConfirm: () => {
          const selectedGroupId = document.getElementById('typeSelect').value
          if (!selectedGroupId) {
            this.$swal.showValidationMessage('Please select a group')
            return false
          }
          return selectedGroupId
        },
      }).then(result => {
        if (result.isConfirmed) {
          const payload = {
            certificate_type_id: result.value,
          }

          axios.put(`certificate/${this.$route.params.MCR_id}/${id}`, payload)
            .then(() => {
              this.$toast.success('Certificate added to type!')
              this.$refs.generalTable.getAllData(1)
            })
            .catch(() => {
              this.$toast.error('Failed to add certificate.')
            })
        }
      })
    },
  },
}
</script>

<style scoped>
/* One group per line with a visible divider - readable like the Engineer List table. */
.cert-group-list {
  list-style: none;
  margin: 0;
  padding: 0;
  min-width: 220px;
  text-align: left;
  border: 1px solid #d8d6de;
  border-radius: 4px;
  background: #fff;
}
.cert-group-list li {
  padding: 4px 8px;
  border-bottom: 1px solid #d8d6de;
  font-size: 0.9rem;
  line-height: 1.35;
  color: #5e5873;
  white-space: normal;
}
.cert-group-list li:last-child {
  border-bottom: none;
}
</style>
